var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { action, makeObservable, observable, runInAction } from 'mobx';
import { Breadcrumb } from '~/views/molecules/nav.breadcrumbs';
import { BaseService, BaseSingletonService, Injectable, Singleton } from './service.base';
import { EBreadcrumbKey } from '~/shared/types';
export let UIOpenService = class UIOpenService extends BaseService {
    open = false;
    openedItem;
    constructor() {
        super();
        makeObservable(this);
    }
    handleOpen = () => (this.self.open = true);
    handleClose = () => (this.self.open = false);
    handleToggle = () => (this.self.open = !this.open);
    setOpenedItem = (openedItem) => (this.self.openedItem = openedItem);
};
__decorate([
    observable,
    __metadata("design:type", Object)
], UIOpenService.prototype, "open", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], UIOpenService.prototype, "openedItem", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], UIOpenService.prototype, "handleOpen", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], UIOpenService.prototype, "handleClose", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], UIOpenService.prototype, "handleToggle", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], UIOpenService.prototype, "setOpenedItem", void 0);
UIOpenService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [])
], UIOpenService);
export let UIOpenDynamicItemsService = class UIOpenDynamicItemsService extends BaseService {
    openedItems = {};
    constructor() {
        super();
        makeObservable(this);
    }
    handleOpen = (keyId) => (this.self.openedItems = { ...this.openedItems, [keyId]: true });
    handleClose = (keyId) => (this.self.openedItems = { ...this.openedItems, [keyId]: false });
    handleToggle = (keyId) => (this.self.openedItems = { ...this.openedItems, [keyId]: !this.openedItems[keyId] });
    handleClear = () => (this.self.openedItems = {});
};
__decorate([
    observable,
    __metadata("design:type", Object)
], UIOpenDynamicItemsService.prototype, "openedItems", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], UIOpenDynamicItemsService.prototype, "handleOpen", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], UIOpenDynamicItemsService.prototype, "handleClose", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], UIOpenDynamicItemsService.prototype, "handleToggle", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], UIOpenDynamicItemsService.prototype, "handleClear", void 0);
UIOpenDynamicItemsService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [])
], UIOpenDynamicItemsService);
export let UIBreadcrumbsService = class UIBreadcrumbsService extends BaseService {
    children = [_jsx(Breadcrumb.Funds, {}, 0)];
    constructor() {
        super();
        makeObservable(this);
    }
    use = (breadcrumbs = []) => {
        const items = breadcrumbs.map((p, i) => {
            switch (p.key) {
                case EBreadcrumbKey.repository:
                    return _jsx(Breadcrumb.Funds, {}, i);
                case EBreadcrumbKey.media:
                    return _jsx(Breadcrumb.Media, {}, i);
                case EBreadcrumbKey.recent:
                    return _jsx(Breadcrumb.Recent, {}, i);
                case EBreadcrumbKey.books:
                    return _jsx(Breadcrumb.Books, {}, i);
                case EBreadcrumbKey.contacts:
                    return _jsx(Breadcrumb.Contacts, {}, i);
                case EBreadcrumbKey.subCategory:
                    return (_jsx(Breadcrumb.SubCategory, { index: i, breadCrumbName: p.breadcrumbName || '', breadCrumbId: p.breadcrumbId || '' }, i));
                default:
                    return _jsx(Breadcrumb.Funds, {}, i);
            }
        });
        runInAction(() => (this.children = items));
    };
};
__decorate([
    observable,
    __metadata("design:type", Object)
], UIBreadcrumbsService.prototype, "children", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], UIBreadcrumbsService.prototype, "use", void 0);
UIBreadcrumbsService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [])
], UIBreadcrumbsService);
export let UIService = class UIService extends BaseSingletonService {
    drawerSvc;
    drawerLibrarySvc;
    drawerAboutSvc;
    breadcrumbsSvc;
    constructor(drawerSvc, drawerLibrarySvc, drawerAboutSvc, breadcrumbsSvc) {
        super();
        this.drawerSvc = drawerSvc;
        this.drawerLibrarySvc = drawerLibrarySvc;
        this.drawerAboutSvc = drawerAboutSvc;
        this.breadcrumbsSvc = breadcrumbsSvc;
        this.drawerSvc.setOpenedItem('DRAWER_ITEM_FUNDS');
    }
    static TOOLBAR_HEIGHT = 64;
    static TOOLBAR_SEARCH_HEIGHT = 72;
    static BOTTOMBAR_HEIGHT = 64;
};
UIService = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [UIOpenService,
        UIOpenService,
        UIOpenService,
        UIBreadcrumbsService])
], UIService);
